import { useEffect } from "react";

import { useRightRail } from "@/context/RightRailContext";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useKaiChat } from "./KaiChatContext";
import { KaiConversationList } from "./KaiConversationList";

/** Mobile / tablet Kai history — sheet overlay (desktop uses {@link KaiHistorySidebar}). */
export function KaiHistoryRail() {
  const kai = useKaiChat();
  const { setMobileRailOpen } = useRightRail();

  useEffect(() => {
    if (kai?.historyOpen) setMobileRailOpen(false);
  }, [kai?.historyOpen, setMobileRailOpen]);

  if (!kai) return null;

  const {
    historyOpen,
    closeHistory,
    conversations,
    activeId,
    selectConversation,
    startNewChat,
  } = kai;

  return (
    <Sheet open={historyOpen} onOpenChange={(open) => !open && closeHistory()}>
      <SheetContent
        side="left"
        className="glass-overlay flex h-full max-h-[var(--app-vvh,var(--app-vh,100vh))] w-[min(24rem,92vw)] flex-col gap-0 overflow-hidden border-border/60 p-0 sm:max-w-md lg:hidden"
      >
        <SheetHeader className="shrink-0 border-b border-border/60 px-5 py-4 text-left">
          <SheetTitle>Chat history</SheetTitle>
          <SheetDescription>
            Browse past conversations or start a new chat.
          </SheetDescription>
        </SheetHeader>
        <KaiConversationList
          conversations={conversations}
          activeId={activeId}
          onSelect={selectConversation}
          onNewChat={startNewChat}
          variant="plain"
          className="min-h-0 flex-1 px-5 py-4"
        />
      </SheetContent>
    </Sheet>
  );
}
